import CellButton from "../components/cells/CellButton";
import CellButtonWithResultStatus from "../components/cells/CellButtonWithResultStatus";
import CellButtonWithCopy from "../components/cells/CellButtonWithCopy";
import CellButtonWithActionIcons from "../components/cells/CellButtonWithActionIcons";
import CellButtonWithIcon from "../components/cells/CellButtonWithIcon";
import CellTestNurturingAutomationStatus from "../components/cells/CellTestNurturingAutomationStatus";
import CellEmailTemplateActions from "../components/cells/CellEmailTemplateActions";
import CellHilTemplateActions from "../components/cells/CellHilTemplateActions";
import CellHilTemplateGeneratedType from "../components/cells/CellHilTemplateGeneratedType";
import CellHilSegmentsAttentionActions from "../components/cells/CellHilSegmentsAttentionActions";
import CellOfferActions from "../components/cells/CellOfferActions";
import CellOfferHeadline from "../components/cells/CellOfferHeadline";
import CellOfferActiveToggle from "../components/cells/CellOfferActiveToggle";
import CellStatusDropdown from "../components/cells/CellStatusDropdown";
import CellRunLogStatusWithRetry from "../components/cells/CellRunLogStatusWithRetry";
import CellChipArray from "../components/cells/CellChipArray";
import CellChipStatus from "../components/cells/CellChipStatus";
import CellCountWithIcon from "../components/cells/CellCountWithIcon";
import CellDate from "../components/cells/CellDate";
import CellImage from "../components/cells/CellImage";
import CellInfoTooltip from "../components/cells/CellInfoTooltip";
import CellNumber from "../components/cells/CellNumber";
import CellPopoverInfo from "../components/cells/CellPopoverInfo";
import CellRate from "../components/cells/CellRate";
import CellText from "../components/cells/CellText";
import CellTime from "../components/cells/CellTime";
import CellTextWithCopy from "../components/cells/CellTextWithCopy";
import CellMetadataModal from "../components/cells/CellMetadataModal";
import CellResourceName from "../components/cells/CellResourceName";
import CellDateTimeUTC from "../components/cells/CellDateTimeUTC";
import CellDateTimeDealer from "../components/cells/CellDateTimeDealer";

export const getRenderComponent = (type: string | null = null) => {
  const map = {
    BUTTON: CellButton,
    BUTTON_WITH_RESULT_STATUS: CellButtonWithResultStatus,
    BUTTON_WITH_COPY: CellButtonWithCopy,
    RESOURCE_NAME: CellResourceName,
    STATUS: CellChipStatus,
    CHIP_ARRAY: CellChipArray,
    TEXT: CellText,
    TEXT_WITH_COPY: CellTextWithCopy,
    INFO_TOOLTIP: CellInfoTooltip,
    POPOVER_INFO: CellPopoverInfo,
    NUMBER: CellNumber,
    DEFAULT: CellText,
    DATE: CellDate,
    TIME: CellTime,
    DATETIME_UTC: CellDateTimeUTC,
    DATETIME_DEALER: CellDateTimeDealer,
    COUNT_WITH_ICON: CellCountWithIcon,
    BUTTON_WITH_ICON: CellButtonWithIcon,
    BUTTON_WITH_ACTION_ICONS: CellButtonWithActionIcons,
    TEST_NURTURING_AUTOMATION_STATUS: CellTestNurturingAutomationStatus,
    OFFER_ACTIONS: CellOfferActions,
    RUN_LOG_STATUS_WITH_RETRY: CellRunLogStatusWithRetry,
    OFFER_HEADLINE: CellOfferHeadline,
    OFFER_ACTIVE_TOGGLE: CellOfferActiveToggle,
    EMAIL_TEMPLATE_ACTIONS: CellEmailTemplateActions,
    HIL_TEMPLATE_ACTIONS: CellHilTemplateActions,
    HIL_TEMPLATE_GENERATED_TYPE: CellHilTemplateGeneratedType,
    HIL_SEGMENTS_ATTENTION_ACTIONS: CellHilSegmentsAttentionActions,
    EMAIL_TEMPLATE_SEGMENT_NAME: CellText,
    EMAIL_TEMPLATE_STATUS_DROPDOWN: CellStatusDropdown,
    RATE: CellRate,
    IMAGE: CellImage,
    METADATA_MODAL: CellMetadataModal,
  };

  if(!type) return CellText;

  return map[type] || null;
};
